import Storage from "./Storage";

export class FlowStorage {
  static resetLastFlowExecution() {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.startsWith("olga.flow.counters")) {
        localStorage.removeItem(key);
      }
    }
    window.dispatchEvent(new CustomEvent("LOADED_FLOW_REPORT", {}));
  }

  static setLastFlowExecution(reports) {
    Storage.set(`olga.flow.counters.last_execution`, reports?.created_at);
    for (const s of reports?.steps || []) {
      Storage.set(`olga.flow.counters.${s.box_id}.${s.source || "has"}`, {
        ...s,
        state: reports?.state,
      });
    }
    window.dispatchEvent(new CustomEvent("LOADED_FLOW_REPORT", {}));
    return true;
  }

  static getLastFlowExecution() {
    Storage.get(`olga.flow.counters.last_execution`);
  }

  static getLastBoxExecution(box_id, source = "has") {
    return Storage.get(`olga.flow.counters.${box_id}.${source || "has"}`);
  }

  static setFlowType(flow_id, type) {
    return Storage.set(`olga.flow.${flow_id}.type`, type);
  }

  static getFlowType(flow_id) {
    return Storage.get(`olga.flow.${flow_id}.type`);
  }
}
